export default "__VITE_ASSET__CV9Wp7bD__"